import { render, staticRenderFns } from "./ConsumoReport.vue?vue&type=template&id=e023c4bc&"
import script from "./ConsumoReport.vue?vue&type=script&lang=js&"
export * from "./ConsumoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports